import React from "react";

const Mail = () => {
    let URL_REF = `https://ferrero-es.playmotiv.xyz/refpwd/`

    const user = {
        userName: "wojtek"
    }
  return (
    <div
      className="mail-container"
      style={{backgroundColor:"aliceblue", padding:"25px"}}
    >
      <div className="logo"
            style={{margin:"20px auto", width:"480px"}}

      >
        <img 
        style={{width:"100%", height:"auto"}}
        src="https://ferrero-es.playmotiv.xyz/media/es/images/logo" />
      </div>

      <div className="content">
        <h4 style={{ fontSize:"24px"}}>{user.userName}</h4>

        <p style={{ fontSize:"16px"}}>
          Gracias por usar nuestro sitio web, el enlace para cambiar su
          contraseña se encuentra a continuación.
        </p>
        <p>
        <a style={{ fontSize:"16px"}} href={`${URL_REF}`}>{`${URL_REF}`}</a>
        </p>
        <p style={{ fontSize:"16px"}}>Un saludo !</p>
      </div>
    </div>
  );
};

export default Mail;
